<template>
  <div>
    <v-data-table
      :items="logs"
      :headers="headers"
      :footer-props="{
        'items-per-page-text': 'Տողեր մեկ էջի համար',
      }"
    ></v-data-table>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "Logs",
  data: () => {
    return {
      url: process.env.VUE_APP_BACKEND_URL,
      logs: [],
      headers: [
        { text: "#", value: "i", width: "5%" },
        { text: "Ժամանակ", value: "date", width: "10%" },
        { text: "Գործողությունների նկարագրություն", value: "log" },
      ],
    };
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
  methods: {
    getLogs() {
      // const path = "/admin/log";
      const config = {
        method: "POST",
        headers: {
          Authorization: this.getUser.jwt,
        },
      };
      fetch(`${this.url}/admin/log`, config)
        .then((response) => response.text())
        .then((result) => {
          // this.logs = result;
          let c = result.split("\n");
          let logs = [];
          for (let i = 0; i < c.length; i++) {
            let log = c[i].split("] ")[1];
            let date = c[i].split("] ")[0];

            date = date?.split("[")[1];
            // date = date.split(': ')[0]
            date = date?.split(" ")[0];

            if (!Number.isInteger(parseInt(date))) {
              date = "";
            }
            let data = {
              date: date,
              log: log,
            };
            logs.push(data);
            // if (c[i][0] == "[" || Number.isInteger(parseInt(c[i][0]))) {
            //   logs.push(c[i]);
            // } else {
            //   logs[logs.length - 1] += " " + c[i];
            // }
          }
          this.logs = logs.filter(function (el) {
            return el.log && el.date;
          });
          this.logs.map((i, index) => {
            i.i = index;
          });
        })
        .catch((error) => console.log("error", error));
    },
  },
  mounted() {
    this.getLogs();
  },
};
</script>

<style>
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
